import * as Yup from 'yup'

export const initialVrEndValues = {
  name: '',
  date: '',
  shift: '',
  message: '',
  timeIntake: 0,
  timeIntakeDescription: '',
  timeWp: 0,
  timeWpDescription: '',
  timePwdDryer: 0,
  timePwdDryerDescription: '',
  timeMpcDryer: 0,
  timeMpcDryerDescription: '',
  timePwdPkg: 0,
  timePwdPkgDescription: '',
  timeMpcPkg: 0,
  timeMpcPkgDescription: '',
  timeButter: 0,
  timeButterDescription: '',
  timeDocumentation: 0,
  timeDocumentationDescription: '',
  timeAdditional: 0,
  timeAdditionalDescription: '',
  timeTotal: 0,
}

export const VrEndSchema = Yup.object().shape({
  logId: Yup.string(),
  name: Yup.string(),
  date: Yup.string(),
  shift: Yup.string(),
  message: Yup.string(),
  timeIntake: Yup.number(),
  timeIntakeDescription: Yup.string(),
  timeWp: Yup.number(),
  timeWpDescription: Yup.string(),
  timePwdDryer: Yup.number(),
  timePwdDryerDescription: Yup.string(),
  timeMpcDryer: Yup.number(),
  timeMpcDryerDescription: Yup.string(),
  timePwdPkg: Yup.number(),
  timePwdPkgDescription: Yup.string(),
  timeMpcPkg: Yup.number(),
  timeMpcPkgDescription: Yup.string(),
  timeButter: Yup.number(),
  timeButterDescription: Yup.string(),
  timeDocumentation: Yup.number(),
  timeDocumentationDescription: Yup.string(),
  timeAdditional: Yup.number(),
  timeAdditionalDescription: Yup.string(),
  timeTotal: Yup.number(),
})
